import { toast } from "sonner";

// Kept here rather than in twClasses, which drags the colour picker in: this file is
// imported by the DTOs (@dto/period).
const TW_ToastLinkAction = "text-sm text-blue-600 underline underline-offset-2 whitespace-nowrap cursor-pointer hover:text-blue-800";

export function toastError(message: string) {
    // toast.error(message, {
    //     unstyled: true,
    //     classNames: {
    //         toast: 'bg-red-400',
    //         title: 'text-red-400 text-base',
    //         description: 'text-red-400',
    //         actionButton: 'bg-zinc-400',
    //         cancelButton: 'bg-orange-400',
    //         closeButton: 'bg-lime-400',
    //     }
    // })
    toast.error(message);
}

export function toastSuccess(message: string) {
    toast.success(message);
}

// A success toast offering an action, shown as a link
export function toastSuccessWithLink(message: string, linkLabel: string, onLinkClick: () => void) {
    toast.success(message, {
        action: { label: linkLabel, onClick: onLinkClick },
        classNames: { actionButton: TW_ToastLinkAction },
    });
}